<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-xs-12">
        <div class="box text-center">
          <!-- /.box-header -->
          <div class="box-body">
            <div class="row center-block">
              <!--<h2>Data tables</h2>-->
              <div class="col-xs-12 text-left">
                <button class="btn btn-default m-y-10 inline-block" @click="clearCId">
                  <i class="fa fa-plus" aria-hidden="true"></i> 新增門市群組
                </button>
                <button class="btn btn-danger pull-right m-y-10 " data-toggle="modal" data-target="#delModal" @click="delModalOpen"><i class="fa fa-trash"></i></button>
              </div>
              <div class="col-xs-12 col-md-2 bg-light-gray select-element-block text-left">
                <div class="select-element" v-for="(storeClass, index) in storeClassList" :class="{'active': curId === storeClass.id}" @click="clickOption(storeClass)">
                  <span class="text-w-600">{{storeClass.name}}</span>
                </div>
              </div>
              <div class="col-xs-12 col-md-10">
                <div class="box-body" style="padding-top: 0px">
                  <div class="row m-b-15">
                    <div class="row center-block text-left">
                      <div>
                        <div class="input-group">
                          <span class="input-group-addon"><span class="text-red">＊ </span>門市群組名稱</span>
                          <input class="form-control" placeholder="" type="text" v-model="info.name" maxlength="45">
                        </div>
                        <br />
                      </div>
                      <div>
                        <h5>選擇店家</h5>
                        <!-- 參與店家 -->
                        <muti-select-two :setting="addStoresSetting" :reNew="reNew" :reSet="reSet"></muti-select-two>
                      </div>
                    </div>
                  </div>
                  <!-- /.box-body -->
                  <div class="box-footer text-center">
                    <button class="btn btn-default" @click="$router.go(-1)">
                      取消
                    </button>
                    <button class="btn btn-success" @click="checkStoreClass(1)" v-if="!curId">
                      新增
                    </button>
                    <button class="btn btn-success" @click="checkStoreClass(2)" v-else>
                      編輯
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </section>
</template>

<script>
import matcherModal from '../../elements/Modal.vue'

export default {
  name: 'store-group',
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      content: {
        bindingStoreList: []
      },
      show: {
        back: false
      },
      storeId: 0,
      info: {
        name: ''
      },
      addStoresSetting: {
        class: 'class-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0,
      storeBrief: [],
      delOption: {
        id: 'delModal',
        title: '刪除',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'del'
          }
        ]
      }
    }
  },
  created () {
    this.getStoreBrief()
  },
  mounted () {

  },
  methods: {
    delModalOpen (bind) {
      this.delOption.title = '刪除' + this.info.name
    },
    trigger (event) {
      if (event === 'del') {
        this.del(this.info.name)
      }
    },
    del (delName) {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeClass/' + this.info.id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getStoreBrief()
        }
      })
    },
    getStoreBrief (clear) {
      this.addStoresSetting.options = []
      this.storeBrief = []
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.addStoresSetting.options.push(obj)
            self.storeBrief.push(obj)
          }
          if (!clear) {
            self.getStoreClassList()
          }
          self.reNew++
        }
      })
    },
    getStoreClassList () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeClassList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          self.storeClassList = sList
          if (sList.length) self.clickOption(sList[0])
        }
      })
    },
    clickOption (option) {
      var self = this
      this.addStoresSetting.options = []
      self.curId = option.id
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++
          self.addStoresSetting.options = self.storeBrief
          self.getCurStoreClass()
        })
      }
    },
    getCurStoreClass () {
      this.addStoresSetting.choose = []
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class
          self.info = classInfo
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id)
          })
        }
      })
    },
    checkStoreClass (type) {
      var msg = ''
      if (!this.info.name) msg = '群組名稱未填'
      else if (!this.addStoresSetting.choose.length) msg = '店家未選擇'
      this.getToast(msg, type)
    },
    getToast (msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else this.upStoreClass(type)
    },
    upStoreClass (type) {
      var self = this
      var method = 'post'
      var url = '/brand/' + this.$route.params.brand_id + '/storeClass'
      if (type === 2) {
        method = 'put'
        url = url + '/' + this.curId
      }
      var data = {
        name: this.info.name,
        store_id: []
      }
      self.addStoresSetting.choose.forEach(function (store) {
        data.store_id.push(store)
      })
      this.getDataH(method, url, data, function (response) {
        if (response.data.status === 200) {
          self.getStoreBrief()
        }
      })
    },
    clearCId () {
      this.curId = 0
      this.addStoresSetting.choose = []
      this.info = { name: '' }
      this.getStoreBrief(true)
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>
<style lang="sass" scoped>
$light-gray: rgb(238, 238, 238)
$light-gray: rgb(238, 238, 238)
$primary-color: #3c8dbc
.bg-light-gray
  background: $light-gray
.select-element
  padding: 10px 15px
  cursor: pointer
  border-bottom: 2px solid #ddd
.select-element:last-child
  border-bottom: 0px
.select-element:hover, .select-element.active
  background: $primary-color
  color: #fff
.input-group .form-control
  z-index: 1 !important
// .ranges
  display: none
.min-item.active, .hour-item.active, .day.checked
  background: #222d32 !important
.w-200
  width: 180px !important
.m-b-15
  margin-bottom: 15px !important
.btn-all-store
  position: absolute
  right: 10px
  z-index: 30
  top: 0px
.input-white
  border: 0px
@media screen and (max-width: 767px)
  .p-sm-10-p
    padding-right: 10px !important
    padding-left: 10px !important
@media screen and (min-width: 768px)
  .p-sm-10-p
    padding-right: calc(20% - 15px) !important
    padding-left: calc(20% + 10px) !important
@media screen and (min-width: 991px)
  .p-sm-10-p
    padding-right: calc(10% - 10px) !important
    padding-left: 10% !important
</style>
<style lang="sass">
  @media screen and (max-width: 767px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(100vw - 185px)
  @media screen and (min-width: 768px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(50vw - 190px)
  @media screen and (min-width: 991px)
    .input-group .cov-vue-date .cov-datepicker
      max-width: calc(30vw - 190px)
</style>



// WEBPACK FOOTER //
// store-group.vue?71362662